import React from 'react';

import ReportedHashTagsPage from 'components/reportedTags';
const ReportedTags = () => {
  return <ReportedHashTagsPage />;
};
export default ReportedTags;
